<template>
  <div class="qualityMange">
    <div class="mainHeader"> 质量管理 
      <el-popover placement="bottom" width="277" trigger="click" popper-class="popover">
        <div class="title">新建问题类型</div>
        <ul class="nav">
          <li v-for="(item, index) in popoNavList" :key="index"  @click="creatIssBtn(item)">
            <img :src="item.iconPrefix">
            <span>{{ item.name }}</span>
          </li>
        </ul>
        <el-button slot="reference" type="primary" size="mini"><i class="el-icon-plus" style="margin-right:5px"></i>新建质量管理问题</el-button>
      </el-popover>
    </div>
    <ul class="mainNav">
      <li v-for="(item, index) in navList" :class="{ isActive: active == item.id }"
        :key="index" @click.stop="navhandleClick(item.id)" >
        {{ item.name }}
      </li>
    </ul>
    <div class="prjList">
      <el-form ref="issForm" :model="issForm"  inline class="issForm" label-width="80px">
        <el-form-item label="流程名称">
          <el-input v-model="issForm.qualityName" placeholder="请输入流程名称" size="small" @input="getTableData(1)" clearable ></el-input>
        </el-form-item>
        <!-- <el-form-item label="问题类型">
          <el-select v-model="issForm.name" placeholder="请选择"  size="small" clearable filterable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.conPlanName" :value="item.conPlanId"> </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="问题状态">
          <el-select v-model="issForm.qmstatus" placeholder="请选择"  size="small" clearable filterable @change="getTableData(1)">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人">
          <el-input v-model="issForm.createUserName" placeholder="请输入创建人" size="small" @input="getTableData(1)" clearable ></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="issForm.startDate" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="getTableData(1)"
          >
          </el-date-picker>
        </el-form-item>
          <el-form-item label="截止日期">
          <el-date-picker v-model="issForm.endDate" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="getTableData(1)">  
          </el-date-picker>
        </el-form-item>
        <el-form-item >
          <el-button size="small" plain @click="resetBtn" >重置</el-button >
          <el-button size="small" type="primary" @click="getTableData(1)" >查询</el-button >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading" :data="issData" :row-style="rowStyle" :header-cell-style="headerStyle"
        element-loading-text="数据加载中"  highlight-current-row height="100%" class="table"
        >
        <template slot="empty">
          <img :src="zanwu" alt="暂无数据" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column type="index" width="50" label="编号"> </el-table-column>
        <el-table-column prop="qualityName" label="质量管理流程名称" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="modelName" label="关联模型节点" min-width="100px" align="center" />
        <el-table-column prop="processType" label="类型" min-width="100px" align="center" />
        <el-table-column prop="endDate" label="截止日期" min-width="120px" />
        <el-table-column prop="qmstatus" label="问题状态" >
          <template slot-scope="scope">
            <div v-if="scope.row.qmstatus == '已完成'" class="table_class adopt_class"> 已完成 </div>
            <div v-else-if="scope.row.qmstatus == '进行中'" class="table_class approval_class" > 进行中 </div>
            <div v-else-if="scope.row.qmstatus == '已延期'" class="table_class reject_class" > 已延期 </div>
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="创建时间" min-width="120px" />
        <el-table-column prop="createUserName" label="创建人"/>
        <el-table-column  min-width="80px" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="clickChange(scope.row)" >详情</el-button >
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <page :page="page" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="fetchData" class="el-pagination" ></page>
      </div>
    </div>
    <el-dialog v-dialogDrag title="关联模型" :visible.sync="dialogVisible" 
      :close-on-click-modal="false" :close-on-press-escape="false" width="500px" class="dialogQua">
      <div class="diatitle">是否需要关联模型节点</div>
      <el-tree :data="treeList" :props="defaultProps" default-expand-all :expand-on-click-node="false" 
        node-key="folderId" ref="tree" :highlight-current="true"  @current-change="currentOrgChangeHandler"
        >
        <template #default="{ data }">
          <div class="treeContent">
            <img :src="stageImg"  alt="阶段图片" v-if="data.folderType=='2'" class="imgCont"/>
            <img :src="classImg"  alt="分类图片" v-else-if="data.folderType=='0'" class="imgCont"/>
            <img :src="nodeImg"  alt="节点图片" v-else-if="data.folderType=='1'" class="imgCont"/>
            <span style="font-size:14px">{{ data.folderName }}</span>
          </div>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelHander" size="small">取 消</el-button>
        <el-button  type="primary" size="small" @click="addModel">确 定</el-button >
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag  :visible.sync="dialogVisibleForm" :title="userInfo.name+' 发起流程'"
      :close-on-click-modal="false" :close-on-press-escape="false" width="1200px" class="dialogQua dialogFormQua">
      <flow-flow :key="updateKey" ref="flowFlow" @isLaunchBtn="isLaunchBtn"></flow-flow>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelHanderForm" size="small">取 消</el-button>
        <el-button  type="primary" @click="addHander()" size="small" v-if="isLaunch">发起审批</el-button >
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag  :visible.sync="dialogVisibleDetail" title="详情"
      :close-on-click-modal="false" :close-on-press-escape="false" width="1200px" class="dialogQua dialogFormQua">
      <form-detail ref="formDetail"></form-detail>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDetail=false" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bimManage from "@/xgzdService/bimManage-service"
import flowService from "@/CommonDP/service/flow-service";
import quaMange from "@/xgzdService/quaMange-service"
import flowFlow from "./flowForm.vue"
import formDetail from './modules/formDetail.vue'
import page from "@/CommonDP/components/paging";
import { mapState } from "vuex";
export default {
  components: { page , flowFlow ,formDetail},
  data(){
    return{
      active: "",
      issForm:{ endDate:"",
        startDate:"",
        qmstatus:"",
        createUserName:"",
        qualityName:""},
      statusList:[
        {label:"进行中",value:"1"},
        {label:"已延期",value:"2"},
        {label:"已完成",value:"3"},
      ],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      loading: false,
      issData:[ ],
      page: { pageNo: 1, pageSize: 10, totalCount: 0, },
      stageImg:require(`@/views/assets/stage.png`),
      nodeImg:require(`@/views/assets/node.png`),
      classImg:require(`@/views/assets/class.png`),
      defaultProps: {
        children: 'childList',
        label: 'folderName'
      },
      treeList:[],
      dialogVisible:false,
      dialogVisibleForm:false,
      popoNavList:[],
      updateKey:0,
      list:[{name:"全部",id:''}],
      modelId:'',
      isLaunch:false,
      dialogVisibleDetail:false,
      detailKey:0
    }
  },
  computed:{
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo,
      routerParams: (state) => state.projectMg.routerParams,
    }),
    navList(){
      return this.list.concat(this.popoNavList)
    },
    qualitySubmitParam(){
      const {enterpriseId,prjInfo:{prjId}}=this;
      const json = this.$refs.flowFlow.$refs.businessForm.getFormData();
      return {
        endDate:json.endDate||"",
        processTypeId:this.routerParams.flowDefinitionId,
        processType:this.routerParams.name,
        qualityName:json.title,
        type:"0",
        modelId:"",//关联的节点id
        prjId,
        enterpriseId,
        modelComponentRelaList:json.modelComponentRelaList
      }
    },
  },
  mounted(){
    this.getTree()
    this.getTableData(1)
  },
  methods:{
    isLaunchBtn(val){
      this.isLaunch=val;
    },
    async getTableData(index){
      this.loading=true;
      const {issForm:{endDate, startDate, qmstatus, createUserName, qualityName},active,navList,prjInfo:{prjId},enterpriseId,page:{pageSize}} =this;
      const processType=navList.find(ele=>ele.id==active)?.name;
      const params={
        endDateBeginStr:endDate?endDate[0]:"",
        endDateEndStr:endDate?endDate[1]:"",
        startDateBeginStr:startDate?startDate[0]:"",
        startDateEndStr:startDate?startDate[1]:"",
        type:"0",
        qmstatus:qmstatus?.split(""),
        createUserName,
        qualityName,
        processType:processType=="全部"?"":processType,
        processTypeIds:active?active.split(","):[],
        prjId,
        enterpriseId,
        pageNum:index,
        pageSize,
      };
      const {data,totalCount,pageNum} = await quaMange.qualityGet(params);
      this.issData=data;
      this.loading=false;
      this.page.pageNo=pageNum;
      this.page.totalCount=totalCount;
    },
     async getTree() {
      const res = await flowService.queryGroupInfoList(this.enterpriseId);
      const list=res.data.map((item)=>{
        if(item.flowGroupDto.name=="质量巡检")return item.flowDefinitionDtoList
      })
      this.popoNavList=list[0].map((item) => {
        item.iconPrefix= this.getImgUrl(item.iconPrefix);
        return item
      });
    },
     getImgUrl(content) {
      return require(`@/CommonDP/assets/xunhun/${content}.png`);
    },
    navhandleClick(index){
       this.active = index;
       this.resetBtn()
    },
    resetBtn() {
      this.issForm = {};
      this.getTableData(1);
    },
    fetchData(val) {
      this.getTableData(val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getTableData(1);
    },
    creatIssBtn(val){
      this.dialogVisible=true;
      this.getTreeList();
      let params= {
        status: null,
        currentVersionId: val.currentVersionId,
        iconPrefix: val.iconPrefix,
        groupId: val.groupId || "",
        flowDefinitionId: val.id,
        name: val.name,
        flowDescribe: val.flowDescribe,
        flowKey: val.flowKey,
        flowInstanceId: val.flowInstanceId,
        flowBusinessId: val.flowBusinessId,
      };
      this.$store.dispatch("setRouterParams", params);
    },
    async getTreeList(){
      const{prjInfo:{prjId},enterpriseId}=this;
      const {data}=await bimManage.getFolderTree(prjId,enterpriseId);
      this.treeList=data.map((item)=>{
        if(item.parentId==="0")  item.folderType = "2"
        return item
      });;
    },
    currentOrgChangeHandler(val){
      this.modelId=val.folderId;
    },
    //选模型节点取消
    cancelHander(){
      this.dialogVisibleForm=true;
      this.updateKey++
    },
    //选模型节点确定
    addModel(){
      if(this.modelId){
        this.getModel(this.modelId)
      }else{
        this.$message.warning("请先选择模型节点")
      }
    },
    //获取模型节点下面的模型
    async getModel(modelId){
      const {data} = await bimManage.getMoDelByNodeId(modelId);
      if(data&&data.length){
        const fileIds = data.map((item) => item.modeId).join();
        const fileNames = data.map((item) => item.modeName).join();
        const rvtVersion = data.map((item) => item.modelFileVersion).join();
        const noNeedIssue = 'yes';//控制不显示创建批注、批注列表
        const noquaFlow = '0';//控制显示创建质量安全流程、流程清单
        const modelId=this.modelId;
        const {prjId,prjName}=this.prjInfo;
        const { href } = this.$router.resolve({ path: "/modelpro" ,query: { fileIds, fileNames, prjId, prjName, rvtVersion,noNeedIssue,noquaFlow,modelId} });
        window.open(href, "_blank");
      }else{
        this.$message.warning("该节点下面暂无模型，请重新选择")
      }
      
    },
    cancelHanderForm(){
      this.dialogVisibleForm=false;
      this.dialogVisible=false;
    },
    async addHander(){
      const params=this.$refs.flowFlow.getForm()
      if (!this.$refs.flowFlow.$refs.businessForm.validateFormData())return;
      const {data} = await quaMange.addFlowBusiness(params);//添加流程接口
      const submitparams={
        flowBusinessId:data,
        ...this.qualitySubmitParam
      };
      await quaMange.qualityAdd(submitparams);//添加问题接口
      await this.$success('发起流程成功');
      await this.getTableData(1);
      this.dialogVisibleForm=false;
      this.dialogVisible=false;
    },
    async clickChange(row){
      const {data} =await quaMange.getFormDataByBusinessID(row.flowBusinessId);
      let params = {
        status: data.status,
        flowBusinessId: data.flowBusinessId,
        flowInstanceNodeId: data.currentNodeId,
        flowKey: data.businessType,
        flowInstanceId: data.flowInstanceId,
        flowDefinitionId: data.flowDefinitionId,
      };
      this.$store.dispatch("setRouterParams", params);
      this.dialogVisibleDetail=true;
      this.$nextTick(() => {
        this.$refs.formDetail.getInit()
      });
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
  }
}
</script>

<style lang="scss">
.popover{
  height: 198px;
  .title{
    color: #323232;
    font-size: 14px;
    padding: 0 3px;
    margin-bottom: 13px;
  }
  .nav{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    height: calc(100% - 24px);
    li{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 33%;
      cursor: pointer;
    }
  }
}
.dialogQua{
  .el-dialog__body{
    height: 500px;
    overflow: auto;
  }
  .diatitle{
    color: #323232;
    font-size: 14px;
  }
  .treeContent{
    display:flex;
    align-items:center;
    .el-icon-circle-plus{
      margin-left: 20px;
      font-size: 16px;
    }
    .imgCont{
      margin-right: 6px;
    }
  }
}
.dialogFormQua{
  .el-dialog__title{
    font-size: 16px;
    color: #323232;
  }
  .el-dialog__body{
    background: #F4F5FA;
    height: 650px;
    padding:11px 16px 0 16px !important
  }
}
</style>
<style lang="scss" scoped src="./index.scss"/>
